module.exports = __webpack_public_path__ + "img/DSC_0030.b30cb5b6.jpg";